import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-md text-center"
        >
          {/* Animated 404 Illustration */}
          <motion.div
            animate={{
              y: [-5, 5, -5],
              rotate: [0, 2, -2, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="mx-auto mb-8 w-64 h-64"
          >
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="#276191"
                d="M40,-74.3C52.1,-69.3,62.2,-59.3,71.8,-47.2C81.4,-35.1,90.5,-20.9,91.2,-5.9C91.9,9.1,84.2,25,74.3,39.1C64.4,53.2,52.3,65.5,37.8,73.1C23.3,80.7,6.6,83.6,-10.3,80.8C-27.2,78,-44.3,69.5,-58.1,57.5C-71.9,45.5,-82.4,30,-85.3,12.8C-88.2,-4.4,-83.5,-23.3,-73.5,-38.9C-63.5,-54.5,-48.2,-66.8,-32.7,-70.6C-17.2,-74.4,-1.4,-69.7,13.9,-64.1C29.3,-58.5,43.9,-52,40,-74.3Z"
                transform="translate(100 100)"
              />
              <text
                x="100"
                y="110"
                font-family="Arial"
                font-size="40"
                font-weight="bold"
                text-anchor="middle"
                fill="white"
              >
                404
              </text>
            </svg>
          </motion.div>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            Lost in Space?
          </h1>
          <p className="text-gray-600 mb-8 text-lg">
            The page you're looking for has drifted off into the cosmos.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                to="/"
                className="px-6 py-3 bg-[#276191] text-white rounded-md hover:bg-indigo-700 transition-colors shadow-md"
              >
                Beam Me Home
              </Link>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }}>
              <Link
                to="/contact-glowtech-solutions"
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              >
                Contact Mission Control
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default NotFoundPage;
